// AIDEV-NOTE: facility-config; Centralized external links to avoid hardcoded URLs scattered across the app

export const EXTERNAL_LINKS = {
  xercor: {
    url: 'https://www.xercor.com',
    email: 'info@xercor.com',
    phone: '+18447692904',
  },
  // AIDEV-NOTE: iguide-tour; standalone iGUIDE 3D tour, opened in a new tab from
  // the carousel + footer (not embedded), so no CSP frame-src entry is needed.
  // AIDEV-NOTE: social-profiles; the facility's public profiles, listed as `sameAs` in the home
  // page's structured data. The footer links the same two pages.
  social: {
    facebook: 'https://www.facebook.com/storego.selfstorage',
    instagram: 'https://www.instagram.com/storego.selfstorage',
  },
  iguideTour: {
    url: 'https://youriguide.com/storego_/',
  },
} as const
